import { memo } from 'react';
import { EmailDeliveryTemplate } from 'components/templates/EmailDeliveryTemplate';

type Props = {};

export const EmailDeliveryPage = memo((_props: Props) => {
	return <EmailDeliveryTemplate />;
});
